import TieredPricingTableHeader from "./TieredPricingTableHeader";
import TieredPricingTableRow from "./TieredPricingTableRow";
import tieredPricingRules from "./../../tieredPricingRules.json";

export default function TieredPricingTable({attributes}) {

    return (
        <table className={'shop_table'} style={{width: '100%', borderCollapse: 'collapse'}}>
            <thead>
            <TieredPricingTableHeader quantityColumnLabel={attributes.quantityColumnTitle}
                                      discountColumnLabel={attributes.discountColumnTitle}
                                      priceColumnLabel={attributes.priceColumnTitle} attributes={attributes}/>
            </thead>
            <tbody>
            {tieredPricingRules.map(rule => {
                return <TieredPricingTableRow attributes={attributes} isSelected={rule.isSelected} key={rule.quantity}
                                              quantity={rule.quantity} discount={rule.discount} price={rule.price}/>
            })}
            </tbody>
        </table>
    )
}
